import { Link } from 'react-router-dom';
import type { FC } from 'react';

interface MovieCardProps {
  id: number;
  title: string;
  slug: string;
  category: string;
  year: number;
  rating: number;
  poster: string;
  isHot?: boolean;
  isNew?: boolean;
  size?: 'normal' | 'large';
}

export const MovieCard: FC<MovieCardProps> = ({
  id,
  title,
  slug,
  category,
  year,
  rating,
  poster,
  isHot,
  isNew,
  size = 'normal',
}) => {
  return (
    <Link
      to={`/movie/${slug}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className={`relative overflow-hidden rounded-lg ${
        size === 'large' ? 'aspect-[2/3]' : 'aspect-[3/4]'
      }`}>
        <img
          src={poster}
          alt={title}
          title={`${title} - 高清电影在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-background-950/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        
        <div className="absolute top-2 left-2 flex gap-1.5">
          {isHot && (
            <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-accent-500 text-accent-50 whitespace-nowrap">
              热播
            </span>
          )}
          {isNew && (
            <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-primary-500 text-background-950 whitespace-nowrap">
              新上
            </span>
          )}
        </div>

        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 rounded-md text-xs font-semibold bg-background-950/70 text-primary-400 whitespace-nowrap">
            {rating}
          </span>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
          <span className="text-xs text-foreground-300">{year} / {category}</span>
        </div>
      </div>
      
      <div className="mt-2.5">
        <h3 className="text-sm font-medium text-foreground-100 group-hover:text-primary-400 transition-colors duration-200 line-clamp-1">
          {title}
        </h3>
      </div>
    </Link>
  );
};

export default MovieCard;